/**
 * Manual override of how each filter reads in Amplitude + the allowlist: only
 * filters listed here emit. Commented entries are scaffolding (MERCH-100).
 */
export const SEARCH_FILTER_LABELS: Record<string, string> = {
  show_reserve: 'Credit Bid or Reserve Disclosed',
  // property_type: 'Property Type',
  // asset_type: 'Sale Format',
  // auction_format: 'Auction Format',
  // occupancy_status: 'Occupancy Status',
  // financing_available: 'Financing Available',
  // listing_type: 'Listing Type',
  // hide_ending_soon: 'Hide Ending Soon',
  // access_available: 'Access Available',
  // presale: 'Presale',
  // no_buyer_premium_filter: 'No Buyer Premium',
  // broker_coop_available: 'Broker Co-op Available',
  // beds: 'Beds',
  // baths: 'Baths',
  // sqft: 'Sqft',
  // distance: 'Distance',
  // marketing_tag: 'Marketing Tag',
}
